export interface ServiceItem {
  id: number;
  name: string;
  description: string;
  duration: string;
  price: string;
  tag?: string;
}

export interface ServiceCategory {
  id: number;
  title: string;
  icon: string;
  services: ServiceItem[];
}

export const serviceCategories: ServiceCategory[] = [
  {
    id: 1,
    title: "ジェルネイル",
    icon: "ri-sparkling-line",
    services: [
      { id: 1, name: "オフのみ", description: "既存のジェルを丁寧にオフします", duration: "30分", price: "¥3,300" },
      { id: 2, name: "シンプルワンカラー", description: "ツヤツヤのワンカラーで上品な仕上がり", duration: "60分", price: "¥6,600" },
      { id: 3, name: "フレンチ / グラデーション", description: "定番フレンチとふんわりグラデーション", duration: "80分", price: "¥8,800", tag: "人気" },
      { id: 4, name: "デザインコース", description: "アートを取り入れたオリジナルデザイン", duration: "90〜120分", price: "¥9,900〜" },
    ]
  },
  {
    id: 2,
    title: "アートネイル",
    icon: "ri-paint-brush-line",
    services: [
      { id: 5, name: "ハンドペイントアート", description: "熟練のアーティストによる手描きアート", duration: "120分", price: "¥13,200", tag: "おすすめ" },
      { id: 6, name: "フラワー3Dアート", description: "立体的な花びらが美しいエンボスアート", duration: "150分", price: "¥16,500" },
      { id: 7, name: "ストーン&チャーム", description: "スワロフスキーやゴールドパーツで装飾", duration: "60分", price: "¥4,400〜" },
      { id: 8, name: "オーロラ/グラデーション", description: "トレンドのオーロラパウダーを使ったデザイン", duration: "100分", price: "¥11,000", tag: "トレンド" },
    ]
  },
  {
    id: 3,
    title: "ケア・スパ",
    icon: "ri-leaf-line",
    services: [
      { id: 9, name: "ハンドケア", description: "甘皮処理・保湿トリートメント", duration: "30分", price: "¥3,300" },
      { id: 10, name: "ネイルスパ", description: "パラフィンパック+ハンドマッサージ付き", duration: "60分", price: "¥6,600", tag: "リラクゼーション" },
      { id: 11, name: "フットジェル", description: "フット専用ジェルネイルコース", duration: "90分", price: "¥8,800" },
      { id: 12, name: "フットスパ & ケア", description: "足元のケアから仕上げまで丁寧に", duration: "60分", price: "¥5,500" },
    ]
  }
];
